import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import AuthCallback from "@/pages/AuthCallback";
import Admin from "@/pages/Admin";
import { I18nProvider, useI18n } from "@/lib/i18n";
import { AuthProvider, useAuth } from "@/context/AuthContext";

// Pulls user.lang from auth into the i18n context once on login.
function SyncUserLang() {
  const { user } = useAuth();
  const { lang, setLangLocal } = useI18n();
  useEffect(() => {
    if (user?.lang && user.lang !== lang && ["ua", "ru", "en"].includes(user.lang)) {
      setLangLocal(user.lang);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.user_id]);
  return null;
}

function AppRouter() {
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <SyncUserLang />
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
